/**
 * Ссылка на форму заявки о расширении лимитов (t_df8944fa).
 *
 * «Заявка на сброс лимитов» — обычная форма сервиса, ответы падают в её раздел
 * «Ответы». Ссылка одна на всё приложение и переопределяется переменной
 * окружения `NEXT_PUBLIC_LIMIT_REQUEST_FORM_URL` без правки кода.
 */
export const LIMIT_REQUEST_FORM_URL =
	process.env.NEXT_PUBLIC_LIMIT_REQUEST_FORM_URL ||
	"https://forms.projme.ru/f/form-pn0e65";
